import React from 'react';
import { createRoot } from 'react-dom/client';

import "~/shared/prefilter";
import LoginApp from './containers/LoginApp';

createRoot(document.getElementById('login-app')).render(
    <LoginApp
        loginApiEndpoint = { LOGIN_API_ENDPOINT }
        registerUrl = { REGISTER_URL }
        passwordResetUrl = { PASSWORD_RESET_URL }
    />
);